"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewPubOrg extends new_item_1.default {
    constructor(newPubOrg) {
        super();
        this.orgCurrency = newPubOrg.orgCurrency;
        if (!newPubOrg.name) {
            throw Error("name required");
        }
        this.name = newPubOrg.name;
        this.websiteUrl = newPubOrg.websiteUrl;
        this.cloneFromId = newPubOrg.cloneFromId;
        this.cloneToId = newPubOrg.cloneToId;
        this.contactEmail = newPubOrg.contactEmail;
        this.contactPhone = newPubOrg.contactPhone;
        this.address = newPubOrg.address;
        this.mfaEnforced = newPubOrg.mfaEnforced;
        this.orgEmailAddress = newPubOrg.orgEmailAddress;
        this.emailAddress = newPubOrg.emailAddress;
        this.free = newPubOrg.free;
        this.tour = newPubOrg.tour;
        this.industry = newPubOrg.industry;
        this.goals = newPubOrg.goals;
    }
}
exports.default = NewPubOrg;
//# sourceMappingURL=new-pubOrg.js.map